


import React, { useState, useEffect } from 'react';
import '../../CSS/Global.css';
import { useSidebar } from '../../SidebarContext';
import Header from '../Header';
import Sidebar from '../SideBar';
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom"

const Earning = () => {
    const { isSidebarOpen } = useSidebar();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [employees, setEmployees] = useState([

    ]);
    const [user, setUser] = useState([])
    const [video, setVideo] = useState([])

    const [image, setImage] = useState("");
    const [preImage, setPreImage] = useState("");

    const [data, setData] = useState({
        user_id: "",
        user_name: "",
        view_type: "",
        video_id: "",
        video: "",
        views_count: "",
        subscribers_count: "",
        estimate_earning: ""
    })
    const navigate = useNavigate();

    const url = process.env.REACT_APP_LINK
    const token = localStorage.getItem("token")


    const fetchUsers = async () => {
        try {
            const response = await fetch(`${url}/api/earningcheck/admin1997`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const data = await response.json();
            setEmployees(data.data.reverse());
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const [filteredEmployees, setFilteredEmployees] = useState(employees);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;


    useEffect(() => {
        const filtered = employees.filter((employee) =>
            Object.values(employee).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredEmployees(filtered);
        setCurrentPage(1);
    }, [searchQuery, employees]);

    const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);
    const currentData = filteredEmployees.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);





    const fetchUsersAll = async () => {
        try {
            const response = await fetch(`${url}/api/earning/admin1997`);
            const data = await response.json();
            // setEmployees(data)
            setUser(data);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    const fetchVideo = async () => {
        try {
            const response = await fetch(`${url}/api/videos/admin1997`);
            const data = await response.json();
            setVideo(data.reverse());
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    useEffect(() => {
        fetchUsersAll()
        fetchVideo();
    }, [])

    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">All Analytics</h1>

                    {/* <button className="oms-add-btn" onClick={() => {
                        setIsModalOpen(true)
                        setData({
                            user_id: "",
                            user_name: "",
                            video_id: "",
                            video: "",
                            views_count: "",
                            subscribers_count: "",
                            estimate_earning: ""
                        });
                    }}>
                        Add Analytics
                    </button> */}

                </div>
                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i>
                    </div>
                </div>

                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>User Id</th>
                                <th>Name</th>
                                <th>Amount</th>
                                <th>Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((employee, index) => (
                                    <tr key={index}>
                                        <td>{(currentPage - 1) * itemsPerPage + index + 1}.</td>
                                        <td>
                                            {employee.staff_id}
                                        </td>
                                        <td>{employee.staff_name}</td>
                                        <td>{employee.amount}</td>
                                        <td>{new Date(employee.createdAt).toLocaleString()}</td>
                                        <td>

                                            <button action="Analytics" onClick={() => navigate(`/staff-earning/${employee.staff_id}`)}>
                                                <i class="fa-solid fa-eye"></i>
                                            </button>
                                        </td>
                                        {/* <td>
                                            
                                        </td> */}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="12" style={{ textAlign: 'center' }}>No users found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="pagination">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                        <i className="fa-solid fa-chevron-left"></i><i className="fa-solid fa-chevron-left"></i>
                    </button>

                    <button className="active">{currentPage}</button>

                    {currentPage + 1 < totalPages && (
                        <>
                            <button onClick={() => paginate(currentPage + 1)}>
                                {currentPage + 1}
                            </button>
                            {currentPage + 2 < totalPages && <span className="dots">...</span>}
                            <button onClick={() => paginate(totalPages)}>
                                {totalPages}
                            </button>
                        </>
                    )}

                    {currentPage === totalPages - 1 && (
                        <button onClick={() => paginate(totalPages)}>
                            {totalPages}
                        </button>
                    )}

                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                        <i className="fa-solid fa-chevron-right"></i><i className="fa-solid fa-chevron-right"></i>
                    </button>
                </div>

            </div>

        </>
    );
};

export default Earning;
